export const loadingInitial = {
  downloadingData: false,
  calculing: false,
  loadingFase1: false,
  loadingFase2: false,
  loadingFase3: false,
  loadingFase4: false,
  loadingFase5: false,
};
